// extracted by mini-css-extract-plugin
module.exports = {"container":"section_container__2i3B2","fullWidth":"section_fullWidth__YzWPc"};